import { Component, OnInit } from '@angular/core';
import { Lab_Interface } from 'src/app/Interface/Lab_Interface';
import { LabService } from 'src/app/Service/Lab/Lab.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-LabCalibration',
  templateUrl: './LabCalibration.component.html',
  styleUrls: ['./LabCalibration.component.scss']
})
export class LabCalibrationComponent implements OnInit {
  QRCodeInput:String=""
  page:number=0;
  Procssing:boolean=false;
  InProccessing:boolean=false;
  modalRef_Download: any;
  modalRef_Upload: any;

  DataList_Lab:Array<Lab_Interface>=[]
  constructor(
    private Lab_Service:LabService,
    private Nav_Service:NavService,
  ) { }

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1090).subscribe(
      data=>{
        this.ReadData_Lab()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }



  ReadData_Lab(){
    this.Procssing=true
    this.Lab_Service.GetLabCalibration().subscribe(
      data=>{


        this.DataList_Lab=data
        this.Procssing=false


      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }



  OnSubmitCalibrationDate(item:Lab_Interface){
    item.Processing=true
    this.Lab_Service.SubmitCalibrationDate(item.id,"").subscribe(
      data=>{
        item.calibration_date=data['calibration_date']
        item.Processing=false


      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }



}
